import type { Type } from '@mend/types/appointment';

/**
 * Restricted list of base appointment types to surface in Signal dashboard.
 * Only these types should appear in filters and widgets per TS-16197.
 *
 * If any of these appointment types are not present in the available data,
 * they should not be surfaced in the filter or shown in the widgets.
 */
export const BASE_APPOINTMENT_TYPES = [
  'Group In Office',
  'Group Video',
  'In Office',
  'Office Video',
  'Phone',
  'Video',
] as const satisfies Type[];

/**
 * Check if a type is a valid base appointment type
 */
export function isBaseAppointmentType(type: Type): type is (typeof BASE_APPOINTMENT_TYPES)[number] {
  return (BASE_APPOINTMENT_TYPES as readonly string[]).includes(type);
}
